(function () {
  'use strict';

  var MOUNT_ID = 'bundle-builder';
  var CONFIG_ID = 'bundle-builder-config';

  var root, cfg, state = { tier: 0, addons: {} };

  // Inject styling: show the bundle's own CTA (an inline style in the block hides it),
  // and hide the theme's native add-to-cart so only the bundle button purchases.
  function injectStyle() {
    var s = document.createElement('style');
    s.setAttribute('data-bbdl', '1');
    s.textContent =
      '#' + MOUNT_ID + ' .bbdl__cta{display:block !important}' +
      '.shop-add-to-cart-wrapper,' +
      '.shop-product-section .shop-add-to-cart-button,' +
      '.shop-product-section .shopify-payment-button,' +
      '.shop-product-section .shopify-payment-button__button{display:none !important}';
    document.head.appendChild(s);
  }

  function money(cents) {
    var c = Math.round(cents);
    return cfg.moneyFormat
      ? cfg.moneyFormat.replace('{{amount}}', (c / 100).toFixed(2))
      : '$' + (c / 100).toFixed(2);
  }

  function tier() { return cfg.tiers[state.tier]; }

  function total() {
    var sum = tier().price;
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) sum += a.price; });
    return sum;
  }

  // Resolve each tier to a real variant. A tier of qty N maps to a variant whose
  // title contains N (e.g. "2-Pack" -> tier qty 2), bought as quantity 1. If no
  // matching pack variant exists yet, fall back to the base variant x N so the
  // page keeps working (same as before the fix) rather than breaking.
  function mapVariants(variants) {
    if (!variants || !variants.length) return;
    var base = variants[0];
    cfg.tiers.forEach(function (t) {
      var match = variants.filter(function (v) {
        return String(v.title).indexOf(String(t.qty)) !== -1;
      })[0];
      if (match) { t.variantId = match.id; t.variantQty = 1; }
      else { t.variantId = base.id; t.variantQty = t.qty; }
    });
  }

  function loadVariants() {
    var path = location.pathname.split('?')[0].replace(/\/$/, '');
    // Only product URLs expose a .js endpoint; guard anyway.
    if (path.indexOf('/products/') === -1) return;
    fetch(path + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.variants) mapVariants(p.variants); })
      .catch(function () { /* leave fallback in place */ });
  }

  function render() {
    var html = '';
    if (cfg.label) html += '<p class="bbdl__label">' + cfg.label + '</p>';
    cfg.tiers.forEach(function (tr, i) {
      var on = i === state.tier;
      html += '<div class="bbdl__tier' + (on ? ' is-on' : '') + '" data-tier="' + i + '">';
      html += '<label class="bbdl__head">';
      html += '<input type="radio" class="bbdl__radio" name="bbdl-tier" value="' + i + '"' + (on ? ' checked' : '') + '>';
      html += '<span class="bbdl__ht"><span class="bbdl__title">' + tr.title + '</span>';
      if (tr.subtitle) html += '<span class="bbdl__sub">' + tr.subtitle + '</span>';
      html += '</span>';
      html += '<span class="bbdl__pr"><span class="bbdl__price">' + money(tr.price) + '</span>';
      if (tr.compareAt && tr.compareAt > tr.price) html += '<span class="bbdl__was">' + money(tr.compareAt) + '</span>';
      html += '</span></label>';
      html += '<div class="bbdl__body">';
      if (cfg.addons && cfg.addons.length) {
        html += '<div class="bbdl__addons">';
        cfg.addons.forEach(function (a) {
          html += '<label class="bbdl__addon">';
          html += '<input type="checkbox" class="bbdl__cb" data-addon="' + a.id + '"' +
            (state.addons[a.id] ? ' checked' : '') + '>';
          if (a.image) html += '<img class="bbdl__thumb" src="' + a.image + '" alt="" loading="lazy">';
          html += '<span class="bbdl__an">+ ' + a.title + '</span>';
          html += '<span class="bbdl__ap">' + money(a.price);
          if (a.compareAt && a.compareAt > a.price) html += '<s>' + money(a.compareAt) + '</s>';
          html += '</span></label>';
        });
        html += '</div>';
      }
      html += '</div></div>';
    });
    html += '<div class="bbdl__total"><span>' + (cfg.totalLabel || 'Total') + '</span><b data-total></b></div>';
    html += '<button type="button" class="bbdl__cta">' + (cfg.ctaLabel || 'Add to cart') + '</button>';
    html += '<p class="bbdl__err">' + (cfg.errorText || 'Please choose an option.') + '</p>';
    root.innerHTML = html;
    paintTotal();
  }

  function paintTotal() {
    var el = root.querySelector('[data-total]');
    if (el) el.textContent = money(total());
  }

  function onChange(e) {
    var el = e.target;
    if (el.name === 'bbdl-tier') { state.tier = parseInt(el.value, 10); render(); return; }
    if (el.hasAttribute('data-addon')) { state.addons[el.getAttribute('data-addon')] = el.checked; paintTotal(); }
  }

  function addToCart() {
    var btn = root.querySelector('.bbdl__cta');
    var t = tier();
    if (!t.variantId) { root.classList.add('has-error'); return; }
    root.classList.remove('has-error');
    btn.disabled = true;
    var items = [{ id: Number(t.variantId), quantity: t.variantQty || 1 }];
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) items.push({ id: Number(a.id), quantity: 1 }); });
    fetch(cfg.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = cfg.afterAdd === 'cart' ? cfg.routes.cart : cfg.routes.checkout; })
      .catch(function () { btn.disabled = false; root.classList.add('has-error'); });
  }

  function boot() {
    root = document.getElementById(MOUNT_ID);
    var node = document.getElementById(CONFIG_ID);
    if (!root || !node) return;
    try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length) return;

    // Seed a safe fallback from any variants already listed in the config.
    if (cfg.variants && cfg.variants.length) mapVariants(cfg.variants);
    (cfg.addons || []).forEach(function (a) { state.addons[a.id] = !!a.checked; });

    injectStyle();
    root.classList.add('bbdl');
    render();
    loadVariants();
    root.addEventListener('change', onChange);
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.bbdl__cta')) addToCart(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
